import moment from 'moment';
import { FC } from 'react';
import { Link } from 'react-router-dom';

import emptyImage from '../../assets/images/emptyImage.svg';
import { Util } from '../../common/util/util';
import { IArticle } from '../../shared/types/articles';

interface IPublicationItemProps {
  publicationSwitchActive?: 'grid' | 'list';
}

export const PublicationItem: FC<IArticle & IPublicationItemProps> = ({
  img,
  title,
  content,
  slug,
  topic_type,
  updated_at,
  publicationSwitchActive,
}) => {
  return (
    <Link
      to={`/articles/${slug}`}
      onClick={() => window.scrollTo({ top: 0, behavior: 'auto' })}
      className={`publication-page-card ${publicationSwitchActive}`}
    >
      <div
        className={`publication-page-card__link ${publicationSwitchActive}`}
        draggable={false}
      >
        <img
          src={img || emptyImage}
          className={`publication-page-card__img ${publicationSwitchActive}`}
          alt="img"
          draggable={false}
        />
      </div>

      <div
        className={`publication-page-card__description ${publicationSwitchActive}`}
      >
        <div className="publication-page-card__category" draggable={false}>
          {topic_type === 'Knowledge::Material'
            ? 'Материалы'
            : 'Knowledge::Equipment'
            ? 'Материалы'
            : 'Процессы'}
        </div>
        <div>
          <h3
            className={`publication-page-card__title ${publicationSwitchActive}`}
          >
            {title}
          </h3>
        </div>
        <div
          className={`publication-page-card__text ${publicationSwitchActive}`}
          dangerouslySetInnerHTML={{
            __html: Util.textByRegex(content)
              ? Util.textByRegex(content)
              : 'Нет описания',
          }}
        />
        <span className="publication-page-card__date">
          {moment(updated_at, 'YYYY-MM-DD').format('DD.MM.YYYY')}
        </span>
      </div>
    </Link>
  );
};

export default PublicationItem;
